<a class="action" [href]="data.link">
    <div *ngIf="square" class="square-thumb" [ngStyle]="{ 'background-image': 'url(' + data.src + ')'}">
    </div>
    <div  *ngIf="!square"  [ngStyle]="{ 'background-image': 'url(' + data.src + ')'}" class="thumb">
    </div>
<!--    <img [alt]="data.title" *ngIf="!square" class="thumb" [src]="data.src">-->
    <div class="text-wrapper">
        <h3>
            <span>{{data.title}}</span>
            <span class="link hover_action">
                <span>{{moreLabel}}</span>
                <app-i-arrow></app-i-arrow>
            </span>
        </h3>
        <p *ngIf="showDescription">
            {{data.description}}
        </p>
    </div>
</a>
